import { useQuery, useQueryClient } from "@tanstack/react-query";
import { fetchClient } from "../generated/client";
import type {
  CreatePersonalAccessTokenBodyDto,
  PersonalAccessTokenDto,
} from "../generated/schema";
import { useApiMutation } from "./use-api-mutation";

const QUERY_KEY = ["get", "personal-access-tokens"];

export function usePersonalAccessTokens() {
  return useQuery<PersonalAccessTokenDto[]>({
    queryKey: QUERY_KEY,
    queryFn: async () => {
      const { data, error } = await fetchClient.GET("/me/access-tokens");
      if (error) throw error;
      return data;
    },
  });
}

function useInvalidateTokens() {
  const queryClient = useQueryClient();
  return () => void queryClient.invalidateQueries({ queryKey: QUERY_KEY });
}

export function useCreatePersonalAccessToken() {
  return useApiMutation("post", "/me/access-tokens", {
    invalidate: useInvalidateTokens(),
    mapVariables: (requestBody: CreatePersonalAccessTokenBodyDto) => ({
      body: requestBody,
    }),
  });
}

export function useRevokePersonalAccessToken() {
  return useApiMutation("delete", "/me/access-tokens/{tokenId}", {
    invalidate: useInvalidateTokens(),
    mapVariables: (tokenId: string) => ({ params: { path: { tokenId } } }),
  });
}
